import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import langAdminDocumentAccess from '../langs/langAdminDocumentAccess';
import LAdmin from '../layouts/LAdmin';
import VAdminDocumentAccess from '../views/VAdminDocumentAccess';

const PAdminDocumentAccess = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminDocumentAccess.title.tag)}</title>
			</Helmet>

			<VAdminDocumentAccess />
		</LAdmin>
	);
};

export default PAdminDocumentAccess;
